// import groupTemplate from '../templates/group.html';
// import groupAddBubbleTemplate from '../templates/groupAddBubble.html';
// import groupHeaderTemplate from '../templates/groupHeader.html';

// import HtmlDom from "../main/HtmlDom";
import AI_helperItemClass from "./ai_helperItemClass";
// import previewHeaderTemplate from "../templates/previewHeader.html";

let AI_helperGroupClass = function(o,app) {
	this.type = 'group';
	this.app = app;
	this.crm = app.crm;
	this.container=null;
	this.amount = 0;
	this.id = 0;
	this.id_good_inet = 0;
	this.name = '';
	this.items = {};
	this.actualAmount = 0;
	this.restAmount = 0;
	this.dom = null;
	this.exceptions = [];
	this.sum = 0;
	this.infoStr = '';
	this.info = null;
	this.ids = [];
	this.gids = [];
	this.wholeSum = 0;
	this.range = 0;
	this.amountAct = 0;
	this.sale = 0;
	this.sale_exceptions = [];
	this.sale_exceptions_cashback = [];
	this.discount_pics_ids = [];
	//this.exc_sales =[];
	this.sale_sum = 0;
	this.cashbackSum = 0;
	this.debug = false;
	this.service_debug = false;
	this.bubble_data = null;
	this.enableStock = true;
	this.infoFields={};
	this.controls={};
	this.containers={};
	this.emptyBubbleData = true;
	this.bubbleItems = [];
	this.bubbleItemClasses = [];
	this.exclude = false;

	this.minimized = false;

	this.initBubbleData = function(bubble_data) {
		this.bubble_data = bubble_data;
		this.proccessBubbleData(bubble_data);
		//console.log('GROUP:bubble_data',bubble_data);
		this.renderInfo();
	};
	this.proccessBubbleData = function() {
		let items = [];
		this.emptyBubbleData = false;
		if (this.bubble_data) {
			for (let k in this.bubble_data) {
				if (Object.prototype.hasOwnProperty.call(this.bubble_data, k)) {
					let v = this.bubble_data[k];

					if (!window.in_array(v.id, this.ids) && v.enableStock || (!v.enableStock && v.has_priv)) {
					// if (!window.in_array(v.id, this.ids)) {
						//console.log('GROUP:V',v);
                        // console.log(v.name, v.enableStock)
						items.push(v);
					}
				}
			}
			// console.log(items)

			this.bubbleItems = this.srt(items);
		}
		if (items.length <= 0) this.emptyBubbleData = true;
		// if (!this.emptyBubbleData) {
		// 	this.controls.add_button.style.display = 'block';
		// } else {
		// 	this.controls.add_button.style.display = 'none';
		// 	this.bubbleDestroy();
		// 	//if (this.containers.content) this.containers.content.innerHTML = '<br /><br />В ЭТОЙ ГРУППЕ ДРУГИХ ТОВАРОВ НЕТ!<br /><br /><br /><br />';
		//
		// }
	};

	this.search = function() {
		// let str = o.value.toString().trim().toLocaleLowerCase();
		// let self = this;
		// if (!this.emptyBubbleData) {
		// 	for (let k in self.bubbleItemClasses) {
		// 		if (Object.prototype.hasOwnProperty.call(self.bubbleItemClasses, k) && self.bubbleItemClasses[k]) {
		// 			let v = self.bubbleItemClasses[k];
		// 			if (v.name) {
		// 				let name = v.name.toString().toLowerCase();
		// 				//console.log(v);
		// 				if (name.indexOf(str) < 0) {
		// 					v.domGroupAdd.style.display = 'none';
		// 				} else {
		// 					v.domGroupAdd.style.display = 'table-row';
		// 				}
		// 			}
		// 		}
		// 	}
		// }
	};

	this.bubbleShow = function () {
		// let self = this;
		// this.bubbleItemClasses=[];
		// this.bubble = new HtmlDom(groupAddBubbleTemplate, {id: this.id, name: this.name}, this);
		// this.containers.content = this.bubble.querySelectorAll('[containers="content"]')[0];
		// this.containers.header = this.bubble.querySelectorAll('[containers="header"]')[0];

		// let header = new HtmlDom(groupHeaderTemplate, {}, this);
		// this.controls.search = this.bubble.querySelectorAll('[controls="search"]')[0];

		// this.containers.header.appendChild(header);


		// this.container.appendChild(this.bubble);
		// if (this.containers.content) {
		// 	this.proccessBubbleData();
		// 	if (!this.emptyBubbleData) {
		// 		for (let k in self.bubbleItems) {
		// 			if (self.bubbleItems.hasOwnProperty(k)) {
		// 				let v = self.bubbleItems[k];
		// 				v.count = v.package;
		// 				v.cnt_per_all = self.amountAct;
		// 				v.sale = self.sale;
		// 				let item = new AI_helperItemClass(v, self, function (param) {self.event(param);}, 'groupAdd');
		// 				item.appendGroupAdd(this.containers.content);
		// 				this.bubbleItemClasses.push(item);
		// 			}
		// 		}
		// 	}
		// }
	};
	this.renderInfo = function() {
		// if (this.dom) {
			this.proccessBubbleData();
			// this.infoFields.amounts.actual.innerHTML = this.actualAmount;
			// this.infoFields.amounts.whole.innerHTML = this.amount;
			// this.infoFields.amounts.rest.innerHTML = this.restAmount;
			// this.controls.info.style.display = 'none';
			// this.controls.info2.style.display = 'none';
			// this.controls.info3.style.display = 'none';
			// if (this.restAmount > 0 && this.amount > 0) {
			// 	this.controls.amounts.style.color = 'red';
			// 	this.controls.add_button.style.background = 'red';
			// } else {
			// 	this.controls.amounts.style.color = 'black';
			// 	this.controls.add_button.style.background = '#0c5b94';
			// }
			let info1 = false;
			let info2 = false;
			let info3 = false;
			if (this.restAmount > 0 && this.amount > 0) {
				if (this.ids.length <= 0) {
					if (this.emptyBubbleData) {
						info3 = true;
					} else {
						info2 = true;
					}
				}
			} else if (this.ids.length <= 0) info1 = true;
			if (info1) {
				this.exclude = true;
				// this.controls.info.style.display = 'table-row';
			}
			if (info2) {
				this.exclude = false;
				// this.controls.info2.style.display = 'table-row';
			}
			if (info3) {
				this.exclude = true;
				// this.controls.info3.style.display = 'table-row';
			}
			// if (info1 || info2 || info3) {
			// 	this.controls.header.style.display = 'none';
			// } else {
			// 	this.controls.header.style.display = 'table-row';
			// }
		// }
	};
	this.bubbleDestroy = function () {
		// if(this.bubble) {
		// 	this.bubble.parentNode.removeChild(this.bubble);
		// 	delete (this.bubble);
		// }
	};
	this.release = function () {
		let items = {};
		for (let k in this.items) {
			if (Object.prototype.hasOwnProperty.call(this.items, k)) {
				let item = this.items[k];
				items[k] = item.release();
			}
		}
		return {
			amount: this.amount,
			id: this.id,
			id_good_inet: this.id_good_inet,
			name: this.name,
			actualAmount: this.actualAmount,
			restAmount: this.restAmount,
			exceptions: this.exceptions,
			sum: this.sum,
			infoStr: this.infoStr,
			ids: this.ids,
			gids: this.gids,
			wholeSum: this.wholeSum,
			range: this.range,
			amountAct: this.amountAct,
			sale: this.sale,
			sale_exceptions: this.sale_exceptions,
			sale_exceptions_cashback: this.sale_exceptions_cashback,
			discount_pics_ids: this.discount_pics_ids,
			sale_sum: this.sale_sum,
			debug: this.debug,
			service_debug: this.service_debug,
			enableStock: this.enableStock,
			items: items,
			restore: true,
			minimized: this.minimized
		}
	};
	this.init = function (o) {
		if (this.crm && this.crm.mainContainer) {
			this.container = this.crm.mainContainer;
		}
		if (o != null) {
			if (typeof o.restore !== "undefined")
				this.init_restore(o);
			else
				this.init_new(o);
		}
	};
	this.init_restore = function (o) {
		// console.log('RESTORE GROUP');
		let self = this;
		this.amount = o.amount;
		this.id = o.id;
		this.id_good_inet = o.id_good_inet;
		this.name = o.name;
		this.actualAmount = o.actualAmount;
		this.restAmount = o.restAmount;
		this.exceptions = o.exceptions;
		this.sum = o.sum;
		this.infoStr = o.infoStr;
		this.ids = o.ids;
		this.gids = o.gids;
		this.wholeSum = o.wholeSum;
		this.range = o.range;
		this.amountAct = o.amountAct;
		this.sale = o.sale;
		this.sale_exceptions = o.sale_exceptions;
		this.sale_exceptions_cashback = o.sale_exceptions_cashback;
		this.discount_pics_ids = o.discount_pics_ids;
		this.sale_sum = o.sale_sum;
		this.debug = o.debug;
		this.service_debug = o.service_debug;
		this.enableStock = o.enableStock;
		this.minimized = o.minimized;
		// if (this.amount !== 0)
			for (let k in o.items) {
				if (Object.prototype.hasOwnProperty.call(o.items, k)) {
					let v = o.items[k];
					// console.log(v)
					let good = new AI_helperItemClass(v, self, function (param) {
						self.event(param);
					},null);
					if (good.priceRub > 0) {
						//	if (self.range > 0) self.amount +=v.package;
						self.items[good.id] = good;
						self.ids.push(good.id);
					}
				}
			}
		if (this.amount < 0) this.amount = 0;
		this.amount = Math.round(this.amount);
		if (this.amount <= 0) {
			// this.ids = [];
			// this.items = {};
		}
		this.getActualAmount(null);
		this.dom = this.createDom();
	};
	this.init_new = function (o) {
		if (this.app) {
			if (this.app.user) if (this.app.user.sale) this.sale = this.app.user.sale;
			if (this.app.user) if (this.app.user.sum) this.wholeSum = this.app.user.sum;
			if (this.app.debug) this.debug = this.app.debug;
			if (this.app.service_debug) this.service_debug = this.app.service_debug;
			if (this.app.sale_exceptions) this.sale_exceptions = this.app.sale_exceptions;
			if (this.app.sale_exceptions_cashback) this.sale_exceptions_cashback = this.app.sale_exceptions_cashback;
			if (this.app.discount_pics_ids) this.discount_pics_ids = this.app.discount_pics_ids;
			//if (this.app.exc_sales)		this.exc_sales 	    =	this.app.exc_sales;
			if (this.app.exceptions) this.exceptions = this.app.exceptions;
		}
		if (o.enableStock) this.enableStock = o.enableStock;
		if (o.info) this.infoStr = o.info;
		if (o.amount) this.amount = parseFloat(o.amount);
		if (o.gids) this.gids = o.gids;
		if (o.range) this.range = parseInt(o.range);
		if (o.id) this.id = parseInt(o.id);
		if (o.id_good_inet) this.id_good_inet = parseInt(o.id_good_inet);
		if (o.item_in_price) this.item_in_price = parseFloat(o.item_in_price);
		if (o.name) this.name = o.name;//+' ('+this.id+')';
		//if (o.items)			this.items			=	o.items;
		let self = this;
		if (this.range < 0) this.amount = 0;
		this.amountAct = this.amount;
		if (this.amount !== 0)
			for (let k in o.items) {
				if (Object.prototype.hasOwnProperty.call(o.items, k)) {
					let v = o.items[k];
					let good = new AI_helperItemClass(v, self, function (param) {
						self.event(param);
					},null);
					if (good.priceRub > 0) {
						//	if (self.range > 0) self.amount +=v.package;
						self.items[good.id] = good;
						self.ids.push(good.id);
					}
				}
			}
		if (this.amount < 0) this.amount = 0;
		this.amount = Math.round(this.amount);
		if (this.amount <= 0) {
			this.ids = [];
			this.items = {};
		}
		this.getActualAmount(null);
		this.dom = this.createDom();
	};
	this.deleteItem = function (item) {
		let self = this;
		self.ids = [];
		if (self.items[item.id]) {
			// self.dom.removeChild(self.items[item.id].dom);
			delete (self.items[item.id]);
		}
		for (let k in self.items) {
			if (Object.prototype.hasOwnProperty.call(self.items, k)) {
				let v = self.items[k];
				self.ids.push(v.id);
			}
		}
		this.event(item);
		//console.log('IDS',self.ids);
	};
	this.event = function () {
		let self = this;
		this.getActualAmount(function () {
			if (self.app) self.app.check_complect();
		});
		this.proccessBubbleData();

		if (this.bubbleItemClasses) {
			for(let key in this.bubbleItemClasses) {
				if (Object.prototype.hasOwnProperty.call(this.bubbleItemClasses, key)) {
					if (this.bubbleItemClasses[key]) {
						this.bubbleItemClasses[key].setSale(this.sale);
					}
				}
			}
		}

		//console.log('bubbleItemClasses',this.bubbleItemClasses);

	};
	this.check_complect = function (param = null) {
		if (param) this.event(param);
		if (this.app) this.app.check_complect();
	};
	this.createDom = function () {
	// 	let model={
	// 		id:this.id,
	// 		name:this.name,
	// 	};
	// 	this.dom = new HtmlDom(groupTemplate, model, this);
	// 	this.controls.header = this.dom.querySelectorAll('[controls="header"]')[0];
	// 	this.controls.add_button = this.dom.querySelectorAll('[controls="add_button"]')[0];
	// 	this.controls.amounts = this.dom.querySelectorAll('[controls="amounts"]')[0];
	// 	this.controls.info = this.dom.querySelectorAll('[controls="info"]')[0];
	// 	this.controls.info2 = this.dom.querySelectorAll('[controls="info2"]')[0];
	// 	this.controls.info3 = this.dom.querySelectorAll('[controls="info3"]')[0];
	// 	this.infoFields.amounts={};
	// 	this.infoFields.amounts.actual = this.dom.querySelectorAll('[model="actual"]')[0];
	// 	this.infoFields.amounts.whole = this.dom.querySelectorAll('[model="whole"]')[0];
	// 	this.infoFields.amounts.rest = this.dom.querySelectorAll('[model="rest"]')[0];
	// 	this.renderInfo();
	// return this.dom;
	};
	this.srt = function (o) {
		let arr = [];
		let self = this;
		for (let k in o) {
			if (Object.prototype.hasOwnProperty.call(o, k)) {
				arr[arr.length] = o[k];
			}
		}
		arr.sort(self.sortArray('name_trunc'));
		return arr;

	};
	this.sortArray = function (field) {
		let order = 1;
		if (field[0] === "-") {
			order = -1;
			field = field.substr(1);
		}
		return function (a, b) {
			let result = (a[field].toLowerCase() < b[field].toLowerCase()) ? -1 : (a[field].toLowerCase() > b[field].toLowerCase()) ? 1 : 0;
			return result * order;
		}
	};
	this.getActualAmount = function (cb) {
		let ret = 0;
		let sum = 0;
		let self = this;
		this.amount = this.amountAct;
		//console.log('ITEMS',this.items);
		for (let k in this.items) {
			if (Object.prototype.hasOwnProperty.call(this.items, k)) {
				let v = this.items[k];
				if (v.enableStock)
					if (!window.in_array(v.id, self.exceptions)) {
						//if (self.range > 0) self.amount +=v.package;
						// ret += parseFloat(v.count)
						ret += !isNaN(parseFloat(v.count)) ? parseFloat(v.count) : 0;
					}
				sum += parseFloat(v.sum)
			}
		}
		if (this.amount < 0) this.amount = 0;
		this.amount = Math.round(this.amount);
		this.actualAmount = ret.toFixed(2);
		this.restAmount = this.amount - this.actualAmount;
		if (this.restAmount < 0) this.restAmount = 0;
		this.sum = sum;
		this.renderInfo();
		if (cb) cb();
	};
	this.append = function () {
		// let self = this;
		for (let k in this.items) {
			if (Object.prototype.hasOwnProperty.call(this.items, k)) {
				let v = this.items[k];
				v.append(this.dom);
			}
		}
		// container.appendChild(this.dom);

	};
	this.addItem = function (item) {
		//console.log(item);
		this.items[item.id] = item;
		this.ids.push(item.id);
		item.append(this.dom);
		//this.bubbleDestroy();
		this.event(item);
		//this.proccessBubbleData();
	};
	this.toCart = function () {
		for (let k in this.items) {
			if (Object.prototype.hasOwnProperty.call(this.items, k)) {
				let v = this.items[k];
				if (v.enableStock)
					v.toCart();
			}
		}
	};
	this.setSale = function (sale, sum) {
		this.sale = sale;
		this.wholeSum = sum;
		this.sale_sum = 0;
		this.cashbackSum = 0;
		let self = this;
		for (let k in this.items) {
			if (Object.prototype.hasOwnProperty.call(this.items, k)) {
				let v = this.items[k];
				if (v.enableStock)
					v.setSale(self.sale, self.wholeSum);
				self.sale_sum += v.sale_sum;
				self.cashbackSum += v.cashbackSum;
			}
		}
	};
	this.init(o);
};//class
export default AI_helperGroupClass;
